import React, {useEffect, useState} from 'react';
import { useParams } from 'react-router-dom';
import {getnearbyData, getHeaderNotification, getFaqsData} from '../../utils/endpoints'
import InnerBanner from '../components/innerBanner';
import InnerContent from '../components/innerContent';
import { Container } from 'react-bootstrap';
import HeaderNotification from '../components/headerNotification';
import Header from '../components/header';
import Faqs from '../components/faq';
import Footer from '../components/footer';
import Loading from '../components/loading';
import { Helmet } from 'react-helmet';


const NathdwaraAttractionDetails = (props) => {
    const [nearbyData, setNearbyData] = useState(null);
    const [faqs, setFaqs] = useState(null);
    const {id} = useParams();
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    const [headerNotificationData, setheaderNotificationData] = useState(null);
    
    useEffect(() => {
        const fetchData = async () => {
          try {
            const nearbyData = await getnearbyData(id);
            const headerNotificationData = await getHeaderNotification();
            const faqs = await getFaqsData();
            setheaderNotificationData(headerNotificationData);
            setNearbyData(nearbyData);
            setFaqs(faqs);
            setIsLoading(false);
          } catch (error) {
            setError(error);
            setIsLoading(false);
          }
        };
      
        fetchData();
      }, [id]);

      const faQSlice = faqs;
      

      if (isLoading) {
        return <div><Loading /></div>;
      }
    
      if (error) {
    return (
    <div className='error_modal'>
      <div className='error_modal-wrapper'>
        <img  src={`${process.env.PUBLIC_URL}/images/logo.png`} alt="Statue of Belief"/>
        <h1>We’re making a few improvements to serve you better. Please check back shortly for an enhanced experience.</h1>
        <button class="reload-btn" onClick={() => window.location.reload()}>
            Reload Page
        </button>
      </div>
    </div>
    );
  }

  return (
    <div>
      <Helmet>
      <title>{nearbyData[0]?.title?.rendered} || Statue of Belief || Worlds tallest shiva Statue</title>
      </Helmet>
      <HeaderNotification compData={headerNotificationData}/>
      <Header />
      <div className='mt-5 pt-5'>
      <Container>
        <h1 className="blog-heading" dangerouslySetInnerHTML={{ __html: nearbyData[0]?.title?.rendered }}></h1>
        <InnerBanner compData={nearbyData[0]?.acf} />
        <InnerContent compData={nearbyData}/>
      </Container>
      </div>
      <Faqs compData={faQSlice.slice(0,5)} />
      <Container>
        {faqs.length > 5 ? <div className='faq_viewMore'><a href="/faqs">View more</a></div> : ''}
        </Container>
      <Footer />
    </div>
  );
};

export default NathdwaraAttractionDetails;